import type { PromptResolve } from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { RegularModal, TextArea } from '@/components_deprecated'
import { DetectBlur } from '@/containers/util-containers'
import { Field } from '@/modules/companies'
import styled from 'styled-components'

const Form = styled.form`
  display: flex;
  flex-direction: column;

  & > div + div {
    margin-top: 1rem;
  }
`

export interface CommentForm {
  comment: string
}

interface CommentPromptProps {
  initialData: CommentForm
  onSubmit: PromptResolve<CommentForm | null>
}

export const CommentPrompt: React.FC<CommentPromptProps> = ({
  initialData,
  onSubmit,
}) => {
  const translations = useTranslate({
    addComment: 'common.add-comment',
    comment: 'common.comment',
    update: 'common.update',
  })

  const {
    formValues: form,
    formValid,
    formChangeHandler: handler,
    submitHandler: submit,
    formErrors,
  } = useForm<CommentForm>({
    values: initialData ?? {
      comment: '',
    },
  })

  return (
    <DetectBlur active onClickOutside={() => onSubmit(null)}>
      <RegularModal
        title={translations.addComment}
        submitText={translations.update}
        submitDisabled={!formValid}
        width="500px"
        onCancel={() => onSubmit(null)}
        onSubmit={submit(onSubmit)}
      >
        <Form>
          <Field>
            <label>{translations.comment}</label>
            <TextArea
              value={form.comment}
              error={formErrors.comment}
              onChange={handler('comment')}
            />
          </Field>
        </Form>
      </RegularModal>
    </DetectBlur>
  )
}
